<script>
  // Patterns
  import Feature from '../Patterns/Feature.svelte';
  import Summary from '../Patterns/Summary.svelte';
  import Connect from '../Patterns/Connect.svelte';

  export let matrix;
  export let hub;

  $: crown = matrix.crown;
  $: navs = matrix.navs;
  $: feature = hub.feature;
  $: summary = hub.summary;
  $: connect = matrix.connect;

</script>

<style></style>

<main>
  <Feature {crown} {navs} {feature}/>
  <Summary {summary} />
  <Connect {connect} />
</main>